import { createContext } from 'react';
import type { Actor, AnyStateMachine } from 'xstate';
import type { Route as RevampRoute } from 'components/app/routes/app-routes-revamp';
import type { Route as LegacyRoute } from 'components/app/routes/app-routes';

type ResponsiveContextType = {
  isMobile: boolean | null;
  isTablet: boolean | null;
  isDesktop: boolean | null;
};

type XStateContextType = {
  machine: AnyStateMachine | null;
  actor: Actor<AnyStateMachine> | null;
};

export type AdobeExperiments = Record<string, boolean | undefined>;

export const XStateContext = createContext<XStateContextType>({
  machine: null,
  actor: null
});

const defaultResponsiveContext: ResponsiveContextType = {
  isMobile: null,
  isTablet: null,
  isDesktop: null
};

export const ResponsiveContext = createContext(defaultResponsiveContext);

type RouteScreenContext = {
  route: RevampRoute | LegacyRoute | null;
  routes: RevampRoute[] | LegacyRoute[];
};

export const RouteScreenContext = createContext<RouteScreenContext>({
  route: null,
  routes: []
});

export const AdobeTargetContext = createContext<AdobeExperiments>({});
